import React from 'react';
import styled from 'styled-components';

import CircularProgress from '@mui/material/CircularProgress';

const Wrapper = styled.div`
  margin-top: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const LoadingIndicator: React.FC<{}> = () => {
  return (
    <Wrapper>
      <CircularProgress />
    </Wrapper>
  );
};

export default LoadingIndicator;
